import { useEffect, useRef, useState } from 'react';

const diferenciais = [
  {
    title: 'Atendimento Estratégico',
    desc: 'Cada cliente recebe atenção personalizada com foco nos seus objetivos de negócio, não apenas na questão jurídica em si.',
    number: '01',
  },
  {
    title: 'Visão Empresarial',
    desc: 'Combinamos expertise jurídica com profundo entendimento do mundo dos negócios para entregar soluções práticas e eficazes.',
    number: '02',
  },
  {
    title: 'Atuação Nacional',
    desc: 'Com base em Curitiba/PR e rede de relacionamentos consolidada, atuamos em todo o território nacional com eficiência.',
    number: '03',
  },
  {
    title: 'Segurança Jurídica',
    desc: 'Análises aprofundadas e pareceres sólidos que garantem que cada decisão seja tomada com total respaldo legal.',
    number: '04',
  },
  {
    title: 'Foco em Resultados',
    desc: 'Nossa atuação vai além da teoria jurídica — comprometemo-nos com resultados reais e mensuráveis para nossos clientes.',
    number: '05',
  },
];

export default function Differentials() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative py-28 lg:py-36 overflow-hidden" ref={ref}
      style={{ background: 'linear-gradient(135deg, #2A0D14 0%, #1A0810 50%, #250C12 100%)' }}
    >
      <div className="relative max-w-7xl mx-auto px-8">
        {/* Header */}
        <div className="max-w-2xl mb-20">
          <div className={`flex items-center gap-4 mb-6 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
            <div className="w-10 h-px bg-kpr-gold" />
            <span className="text-kpr-gold text-xs font-medium tracking-[0.25em] uppercase">Por que nos escolher</span>
          </div>
          <h2 className={`font-serif text-4xl md:text-5xl text-white font-light leading-[1.1] mb-6 transition-all duration-700 delay-100 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
            Nossos Diferenciais
          </h2>
          <p className={`text-white/45 text-[15px] leading-loose font-light transition-all duration-700 delay-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
            O que nos distingue é a capacidade de unir excelência técnica à estratégia de negócios,
            entregando resultados que transformam a trajetória dos nossos clientes.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-0 border border-white/8">
          {diferenciais.map((item, i) => (
            <div
              key={item.title}
              className="group relative p-8 border-r border-white/8 last:border-r-0 hover:bg-white/4 transition-all duration-400 cursor-default overflow-hidden"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(32px)',
                transition: `opacity 0.6s ease ${i * 100}ms, transform 0.6s ease ${i * 100}ms, background 0.3s`,
              }}
            >
              {/* Number watermark */}
              <div className="absolute top-4 right-4 font-serif text-white/5 text-7xl font-light leading-none group-hover:text-kpr-gold/8 transition-colors duration-400 select-none pointer-events-none">
                {item.number}
              </div>

              <div className="relative w-8 h-px bg-kpr-gold/40 group-hover:bg-kpr-gold mb-6 transition-colors duration-300" />

              <h3 className="relative font-serif text-white/90 font-light text-base mb-3 leading-snug">{item.title}</h3>
              <p className="relative text-white/40 text-sm leading-relaxed font-light">{item.desc}</p>

              {/* Top accent */}
              <div className="absolute top-0 left-0 w-0 h-px bg-kpr-gold group-hover:w-full transition-all duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
